import script from "./DressCode.vue?vue&type=script&setup=true&lang=js"
export * from "./DressCode.vue?vue&type=script&setup=true&lang=js"

import "./DressCode.vue?vue&type=style&index=0&id=7ecab042&lang=css"

const __exports__ = script;

export default __exports__